import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SSection, SPopularTag, SSectionTitle } from './styles';
import { useStaticQuery, graphql } from 'gatsby';

function MostPopularTags({ size }) {
  const [popularTags, setPopularTags] = useState([]);
  const { allWpTag } = useStaticQuery(
    graphql`
      query {
        allWpTag(filter: { count: { gt: 0 } }) {
          nodes {
            slug
            name
            posts {
              nodes {
                id
              }
            }
          }
        }
      }
    `,
  );

  useEffect(() => {
    const sortedTags = allWpTag.nodes.sort((a, b) => {
      return a.posts.nodes.length > b.posts.nodes.length ? -1 : 1;
    });

    setPopularTags([...sortedTags].splice(0, size));
  }, [allWpTag]);

  return (
    <SSection>
      <SSectionTitle>Popular Tags</SSectionTitle>
      {popularTags.map(tag => (
        <SPopularTag key={tag.slug} to={`/blog/tags/${tag.slug}/1/`}>
          {tag.name}
        </SPopularTag>
      ))}
      <SPopularTag to="/blog/tags">All Tags</SPopularTag>
    </SSection>
  );
}

MostPopularTags.propTypes = {
  size: PropTypes.number,
};

export default MostPopularTags;
